import { render, staticRenderFns } from "./doHistoryComplaintsList.vue?vue&type=template&id=4c51a4d4&scoped=true"
import script from "./doHistoryComplaintsList.vue?vue&type=script&lang=js"
export * from "./doHistoryComplaintsList.vue?vue&type=script&lang=js"
import style0 from "./doHistoryComplaintsList.vue?vue&type=style&index=0&id=4c51a4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51a4d4",
  null
  
)

export default component.exports